import { Flex, Text, Card, Box, Image } from '@podiumhq/design-system';
import { motion } from 'framer-motion';
import profilepic1 from '../../assets/profile1.png';
import profilepic2 from '../../assets/profile2.png';
import profilepic3 from '../../assets/profile3.svg';
import profilepic4 from '../../assets/profile4.png';
import avatarimg from '../../assets/avatar.svg';
import phoneIcon from '../../assets/phoneIcon.svg';
import playIcon from '../../assets/playIcon.svg';
import volumeIcon from '../../assets/volumeIcon.svg';
import moneyIcon from '../../assets/moneyIcon.svg';
import footerPic from '../../assets/footer.png';
import Testimonial from '../../components/Testimonial';
import { testimonialAttribution, testimonialText } from './content';
import GoogleStars from '../../components/GoogleStars';
import { getPopAnimationProps } from '../../utils';

const DefaultSidebar = () => (
  <Flex
    flexDir="column"
    alignItems="center"
    mt="60px"
    style={{ width: '100%', maxWidth: '410px', position: 'relative' }}
  >
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      style={{
        width: '274px',
        position: 'absolute',
        left: 0,
        right: 0,
        margin: '0 auto',
        zIndex: 1,
      }}
    >
      <CenterCard />
    </motion.div>
    <motion.div
      {...getPopAnimationProps(2, 0.65)}
      style={{ width: '100%', zIndex: 2, position: 'relative', top: '-25px' }}
    >
      <Flex justifyContent="flex-end">
        <RightOneCard />
      </Flex>
    </motion.div>
    <motion.div
      {...getPopAnimationProps(3, 0.65)}
      style={{ width: '100%', zIndex: 2, position: 'relative', top: '-15px' }}
    >
      <Flex justifyContent="flex-end">
        <RightTwoCard />
      </Flex>
    </motion.div>
    <Flex width="100%" justifyContent="space-between" style={{ zIndex: 2 }}>
      <motion.div
        {...getPopAnimationProps(3.5, 0.65)}
        style={{ position: 'relative', top: '-5px' }}
      >
        <LeftCard />
      </motion.div>
      <motion.div
        style={{ position: 'relative', top: '-5px' }}
        {...getPopAnimationProps(4, 0.65)}
      >
        <RightThreeCard />
      </motion.div>
    </Flex>
    <Box mt="60px">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.8 }}
      >
        <Testimonial
          image={footerPic}
          text={testimonialText}
          attribution={testimonialAttribution}
        />
      </motion.div>
    </Box>
  </Flex>
);

export default DefaultSidebar;

const CenterCard = () => (
  <Card color="black.base" p="16px 16px 8px" fontSize="12px">
    <Flex flexDir="column">
      <CenterCardProfile img={profilepic1} />
      <CenterCardProfile img={profilepic2} />
      <CenterCardProfile img={avatarimg} />
      <CenterCardProfile img={profilepic3} />
    </Flex>
  </Card>
);

const CenterCardProfile = ({ img }) => (
  <Flex pb="20px">
    <Box borderRadius="8px" w="34px" h="34px" overflow="hidden">
      <Image w="34px" h="34px" src={img} />
    </Box>
    <Flex flexDir="column" justifyContent="space-between" pl="6px">
      <GreyLine w="100px" />
      <GreyLine w="200px" />
    </Flex>
  </Flex>
);

const LeftCard = () => (
  <Card
    color="black.base"
    p="16px 16px 8px"
    fontSize="12px"
    minHeight="115px"
    w="224px"
  >
    <Flex pb="6px">
      <Box borderRadius="8px" w="34px" h="34px" overflow="hidden">
        <Image w="34px" h="34px" src={profilepic4} />
      </Box>
      <Flex flexDir="column" justifyContent="space-between" pl="6px">
        <Text fontSize="sm" fontWeight="semibold">
          Marty Cooper
        </Text>
        <Box color="grey.light" fontSize="10px">
          Left a review on
          <Box
            color="blue.base"
            display="inline"
            pl="4px"
            sx={{ fontSize: '10px' }}
          >
            Google
          </Box>
        </Box>
      </Flex>
    </Flex>
    <GoogleStars />
    <Box mt="10px" />
    <GreyLine w="100%" />
  </Card>
);

const RightOneCard = () => (
  <Card color="black.base" p="16px" fontSize="12px" minHeight="60px" w="200px">
    <Flex flexDir="row" alignItems="center" h="100%">
      <Box w="6px" h="6px" borderRadius="50%" bg="blue.base" mr="6px" />
      <Image src={avatarimg} w="24px" h="24px" />
      <Flex flexDir="column" ml="6px">
        <Text fontWeight="semibold" fontSize="sm" color="black.lighter">
          Rosie Sims
        </Text>
        <GreyLine w="120px" />
      </Flex>
    </Flex>
  </Card>
);

const RightTwoCard = () => (
  <Card color="black.base" p="13px" fontSize="12px" minHeight="35px" w="145px">
    <Flex flexDir="row" alignItems="center" h="100%">
      <Image src={phoneIcon} w="16px" h="16px" />
      <Image src={playIcon} w="10px" h="10px" />
      <Image src={volumeIcon} w="70px" h="24px" />
      <Text
        color="grey.lighter"
        fontSize="sm"
        fontWeight="normal"
        sx={{ fontSize: '8px' }}
      >
        0:32
      </Text>
    </Flex>
  </Card>
);

const RightThreeCard = () => (
  <Card
    color="black.base"
    p="13px"
    fontSize="12px"
    minHeight="35px"
    w="170px"
    h="50px"
  >
    <Flex flexDir="row" alignItems="center" h="100%">
      <Image src={moneyIcon} w="20px" h="20px" />
      <Text fontSize="sm" fontWeight="semibold" color="black" ml="6px">
        Jane paid $40.00
      </Text>
    </Flex>
  </Card>
);

const GreyLine = ({ w }) => (
  <Box w={w} h="14px" bg="#EEECEA" borderRadius="16px" />
);
